<template>
  <v-layout
    align-center
    justify-center
    class="container"
    :class="{ 'pt-4': $vuetify.breakpoint.smAndUp }"
  >
    <v-layout
      wrap
      class="mb-1"
      :class="{ 'pt-4': $vuetify.breakpoint.smAndUp }"
    >
      <v-flex xs12 pt-4>
        <login-form />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import store from '@/store';
import LoginForm from '@/components/auth/LoginForm.vue';

export default {
  name: 'LoginPage',
  components: {
    LoginForm,
  },
  async beforeRouteEnter(to, from, next) {
    if (!localStorage.getItem('token')) {
      store.commit('auth/setAuthenticated', false);
      localStorage.removeItem('me');
      store.commit('global/setRole', null, { root: true });
    }

    if (store.getters['auth/isAuthenticated']) {
      await store.dispatch('auth/getMyInfo');

      if (store.getters['global/getRole'] === 'investor') {
        next('/investor-board/investor-board-list');
      } else if (store.getters['global/getRole'] === 'mechanic') {
        next('/mechanic/rents');
      } else {
        next('/workers-board/workers-board-list');
      }
    } else {
      next();
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.headline {
  text-align: center;
  text-transform: uppercase;
  color: #fff;

  @media (max-width: 960px) {
    font-size: 18px !important;
  }
}
</style>
